import { render, staticRenderFns } from "./Reputation.vue?vue&type=template&id=bec19ce0"
import script from "./Reputation.vue?vue&type=script&lang=js"
export * from "./Reputation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports